export { StyledTooptip as Tooltip } from './Tooltip.styles';
